import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { SimpleTable } from "@portal/BaseComponents/Table/SimpleTable/AntTable";

import { Invoice } from "@portal/types/entities/invoice";
import { styled } from "@stitches/react";

export const EmptyPlaceHolder = styled(Flex, {
  width: "100%",
  height: "80px",
  backgroundColor: "var(--gray-2)",
  color: "var(--gray-7)",
});

export const AttributeTable = styled(SimpleTable<Invoice>, {
  variants: {
    design: {
      empty: {
        ".ant-table-cell": {
          padding: "0 !important",
          border: "0 !important",
        },
        ".ant-table-footer": {
          display: "none",
        },
      },

      data: {
        ".ant-table-cell": {
          background: "var(--gray-1) !important",
          padding: "12px",
        },
        ".ant-table-footer": {
          background: "var(--gray-1) !important",
          padding: " 12px 20px",
          minHeight: "50px",
        },
        ".ant-table-body": {
          padding: "0 20px 0",
        },

        ".ant-table-header": {
          paddingInline: "20px",
        },
        "&.ant-table-wrapper .ant-table-thead > tr > th,.ant-table-wrapper .ant-table-thead > tr > td":
          {
            borderColor: " var(--gray-6)",
          },

        "&.ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before, .ant-table-wrapper .ant-table-thead > tr > td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before":
          {
            content: "none",
          },
        "&.ant-table-wrapper .ant-table-thead > tr > th, .ant-table-wrapper .ant-table-tbody > tr > th, .ant-table-wrapper .ant-table-tbody > tr > td, .ant-table-wrapper tfoot > tr > th, .ant-table-wrapper tfoot > tr > td":
          {
            padding: "12px",
          },
      },
    },
  },
});
